import { render, staticRenderFns } from "./table-status.vue?vue&type=template&id=670d5ae7"
import script from "./table-status.vue?vue&type=script&lang=js"
export * from "./table-status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports